import React from 'react'
import styles from './A23MiniGameTable.module.css';
import { useGameDefinition } from '@/src/hooks/data/useGameTable';
import { FaPlus } from "react-icons/fa";
import useCreateGame from '@/src/hooks/utils/useCreateGame';

export default function A23AddGameTableDialog({ activeGame }) {
    const gameDefinition = useGameDefinition(activeGame);
    const { initiateCreateTable } = useCreateGame();

    return (
        <div onClick={() => initiateCreateTable(gameDefinition, null, true)} className={styles.addGameContainer}>
            <FaPlus size={12} style={{ color: 'var(--color-primary)' }} />
        </div>
    )
}
